import styled from "styled-components";
import { device } from "../../globalAssets/breakpoints";
import { desktop } from "../../globalAssets/fontsize";
export const DetailsContainer = styled.div`
  height: 80vh;
  width: 100%;
  position: relative;
`;

export const MoreInfoContainer = styled.div`
  height: 100%;
  width: 100%;
  background: ${(props) => props.theme.foreground};
  padding: 0.5vw;
`;

export const MoreDetails = styled.div`
  /* height: 50%; */
  overflow-y: scroll;
  height: 100%;
  padding: 0px 5px 0 0;
  &::-webkit-scrollbar {
    width: 5px;
    background: ${(props) => props.theme.backgroundDim};
  }
  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.background};
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.primaryColor};
    height: 15px;
    border-radius: 5px;
  }
`;

export const Contact = styled.div`
  div {
    display: flex;
    align-items: baseline;
    h2 {
      font-size: 1vw;
      color: ${(props) => props.theme.color};
      text-transform: capitalize;
    }
    h4 {
      font-size: 1vw;
      color: ${(props) => props.theme.color};
      margin: 0;
      margin-right: 10px;
      display: flex;
      align-items: center;
      span {
        font-size: ${desktop.normal};
        color: ${(props) => props.theme.grey};
        /* display: flex; */
        margin-right: 5px;

        /* align-self: baseline; */
      }
    }
  }
`;

export const InfoItem = styled.div`
  margin-bottom: 0.5vw;
  text-align: center;
  h4 {
    font-size: 0.8vw;
    color: ${(props) => props.theme.grey};
    margin: 0;
  }
  h1 {
    font-size: 1.8vw;
    color: ${(props) => props.theme.color};
    margin: 0;
    span {
      font-size: ${desktop.medium};
      color: ${(props) => props.theme.grey};
    }
  }
  h2 {
    font-size: 1vw;
    color: ${(props) => props.theme.grey};
  }
`;
export const Amenities = styled.div`
  & > h1 {
    font-size: 1.3vw;
    color: ${(props) => props.theme.color};
    margin: 0;
  }
  div {
    display: flex;
    & > h3 {
      font-size: 0.85vw;
      color: ${(props) => props.theme.color};
      margin-right: 10px;
      background: ${(props) => props.theme.secondaryColor};
      border-radius: 10px;
      padding: 5px;
    }
  }
`;

export const Description = styled.div`
  width: 100%;
  border-top: ${(props) => `1px solid ${props.theme.grey}`};
  h4 {
    font-size: 0.8vw;
    color: ${(props) => props.theme.grey};
    margin: 0;
  }
  h1 {
    font-size: 1vw;
    color: ${(props) => props.theme.color};
    margin: 0;
  }
`;

export const MobileFilter = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.color};
  font-size: 15px;
  margin: 10px 0;
  font-weight: 500;
  width: fit-content;
  border-bottom: ${(props) => `1px solid ${props.theme.grey}`};
  & > div {
    margin-left: 5px;
    font-size: 15px;
    color: ${(props) => props.theme.color};
    align-items: center;
    display: flex;
    align-items: center;
  }
  @media ${device.laptop} {
    display: none;
  }
`;

export const FilterContainer = styled.div`
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  width: 100%;
  display: none;
  margin-bottom: 10px;
  /* height: 60vh; */
  & > div {
    padding: 5px;
    & > h3 {
      color: ${(props) => props.theme.color};
      font-weight: 600;
      margin: 0;
      font-size: 14px;
      padding: 5px;
      background: ${(props) => props.theme.background};
      box-shadow: ${(props) => props.theme.subtleShadow};
      width: 100%;
    }
  }
  @media ${device.laptop} {
    top: 15vh;
    display: block;
    position: sticky;
    /* overflow-y: auto; */
    & > div {
      padding: 0.5vw;
      & > h3 {
        font-size: ${desktop.small};

        padding: 0.5vw;
      }
    }
  }
`;
